import { render } from "./AdParameterTableItem.vue?vue&type=template&id=4fab845e"
import script from "./AdParameterTableItem.vue?vue&type=script&lang=js"
export * from "./AdParameterTableItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__